var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentEpdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#document--epdf_svg__clip0_61530_7482)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 19.5v-3a1.502 1.502 0 00-1.5-1.5h-3a1.502 1.502 0 00-1.5 1.5V21a1.506 1.506 0 001.5 1.5h3.75V21H16.5v-1.5H21zm-4.5-3h3V18h-3v-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.28 6.97l-5.25-5.25a.75.75 0 00-.53-.22H6A1.502 1.502 0 004.5 3v18A1.502 1.502 0 006 22.5h6V21H6V3h6v4.5A1.502 1.502 0 0013.5 9H18v3h1.5V7.5a.75.75 0 00-.22-.53zM13.5 3.31l4.19 4.19H13.5V3.31z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "document--epdf_svg__clip0_61530_7482"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgDocumentEpdf;